import { faNum, formatPercent } from '@kia/shared';
import { Chip } from './Chip';

/**
 * Cost-confidence chip (E16-02, R-B): how trustworthy a product's COGS is, from the per-line price source.
 * ONE component so every screen (search, master list, deal lines, pricing) reads completeness the same way:
 *   🟢 all priced from ACTUAL (receipt) prices · 🟡 some GROUP estimates · 🔴 any line MISSING a price
 *      (⇒ the COGS shown is understated). `confirmed` is the share of material COST from actual prices.
 */
export function CostConfidence({
  confirmed,
  actualLines,
  groupLines,
  missingLines,
}: {
  confirmed: number;
  actualLines: number;
  groupLines: number;
  missingLines: number;
}) {
  const priced = actualLines + groupLines;
  const title =
    `${faNum(actualLines)} قلم قطعی · ${faNum(groupLines)} قلم تخمینی (قیمت گروه) · ` +
    `${faNum(missingLines)} قلم بدون قیمت`;

  if (priced === 0 && missingLines === 0) {
    return (
      <Chip tone="neutral">
        <span title="این محصول قلم قیمت‌گذاری‌شده‌ای ندارد">—</span>
      </Chip>
    );
  }
  if (missingLines > 0) {
    return (
      <Chip tone="danger">
        <span title={`${title} — بهای تمام‌شده کمتر از واقعیت است`}>
          {faNum(missingLines)} بدون قیمت ⚠
        </span>
      </Chip>
    );
  }
  if (groupLines > 0) {
    return (
      <Chip tone="warn">
        <span title={title}>
          {formatPercent(confirmed)} قطعی · {faNum(groupLines)} تخمینی
        </span>
      </Chip>
    );
  }
  return (
    <Chip tone="success">
      <span title={title}>بها قطعی</span>
    </Chip>
  );
}
